// MOCK DATA — QUINLATE
// Todos los assets (posters + animaciones WebP) descargados de Supabase
// y servidos localmente desde /assets.

export const WHATSAPP_NUMBER = '523317139679';

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

// En celular los enlaces de WhatsApp se abren en la MISMA pestaña: con target="_blank"
// iOS a veces no le pasa el enlace a la app y el cliente termina en WhatsApp Web dentro
// de Safari. En computadora sí van en pestaña nueva, para no sacarlo del sitio.
export const IS_MOBILE =
  typeof navigator !== 'undefined' &&
  (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const waLinkProps = IS_MOBILE ? {} : { target: '_blank', rel: 'noopener noreferrer' };

export const brand = {
  name: 'QUINLATE',
  tagline: 'Pureza real. Oro de ley.',
  // El logo de la Landing es 3D en vivo (components/Logo3D.jsx), ya no un video por tema.
  // Versión estática del logo QUINLATE SHOP (disco negro, letras claras) — header, footer,
  // marcas de fondo de la Landing y fotos provisionales de producto.
  logoStatic: '/assets/logo-shop-circle.webp',
};

// Categorías activas del menú principal — el orden aquí define el orden del menú
export const navLinks = [
  { label: 'Gorras', path: '/gorras' },
  { label: 'Lentes', path: '/lentes' },
  { label: 'Joyería', path: '/joyeria' },
  { label: 'Van Cleef', path: '/van-cleef' },
  { label: 'Conjuntos', path: '/conjuntos' },
  { label: 'Emprende con nosotros', path: '/emprendedor' },
];

// Copy de cada página de categoría (CategoryPage la consume por id)
export const categories = {
  joyeria: {
    eyebrow: '01 — Colección',
    title: 'Joyería',
    sub: 'Oro de ley trabajado a mano. Piezas que no siguen tendencias: las inician.',
  },
  gorras: {
    eyebrow: '02 — Colección',
    title: 'Gorras',
    sub: 'Ediciones premium seleccionadas. La corona de cualquier outfit.',
  },
  lentes: {
    eyebrow: '03 — Colección',
    title: 'Lentes',
    sub: 'Edición Cartier. Ocho tonos, un mismo lenguaje de lujo silencioso.',
  },
  'van-cleef': {
    eyebrow: '04 — Colección',
    title: 'Van Cleef',
    sub: 'Esclava tejida estilo Van Cleef. Un mismo diseño, cuatro actitudes de color.',
  },
  conjuntos: {
    eyebrow: '05 — Colección',
    title: 'Joyería Conjuntos',
    sub: 'Collar y esclava tejidos a juego, con precio de paquete. Combina y ahorra.',
  },
  emprendedor: {
    eyebrow: '06 — Por mayoreo',
    title: 'Emprende con nosotros',
    sub: 'Compra por paquete y revende con margen. Ideal para arrancar tu propio negocio.',
  },
};

const ALL_PRODUCTS = [
  {
    id: 'alo',
    name: 'Gorra ALO',
    category: 'gorras',
    material: 'Edición premium',
    description: 'Gorra ALO premium. Silueta trucker limpia, logo bordado en relieve y malla transpirable. Presencia sin esfuerzo.',
    price: '$999 MXN',
    image: '/assets/alo-poster.webp',
    animation: '/assets/alo.webp',
    gallery: [
      { type: 'animation', src: '/assets/alo.webp', label: 'Video 360°' },
      { type: 'image', src: '/assets/alo-front.webp', label: 'Frente' },
      { type: 'image', src: '/assets/alo-side.webp', label: 'Perfil' },
      { type: 'image', src: '/assets/alo-back.webp', label: 'Trasera' },
    ],
    featured: false,
    details: {
      quilates: null,
      acabado: 'Bordado 3D / malla trucker',
      tallas: ['Unitalla ajustable'],
    },
    variants: [
      {
        id: 'alo',
        name: 'Negro',
        description: 'Gorra ALO premium. Silueta trucker limpia, logo bordado en relieve y malla transpirable. Presencia sin esfuerzo.',
        acabado: 'Bordado 3D / malla trucker, color negro',
        image: '/assets/alo-poster.webp',
        animation: '/assets/alo.webp',
        gallery: [
          { type: 'animation', src: '/assets/alo.webp', label: 'Video 360°' },
          { type: 'image', src: '/assets/alo-front.webp', label: 'Frente' },
          { type: 'image', src: '/assets/alo-side.webp', label: 'Perfil' },
          { type: 'image', src: '/assets/alo-back.webp', label: 'Trasera' },
        ],
      },
      {
        // TEMPORAL: imagen de placeholder (logo de QUINLATE) mientras llegan las fotos
        // reales de producto. Buscar "PLACEHOLDER" para encontrar esta variante y
        // reemplazar "image"/"gallery" en cuanto lleguen las fotos.
        id: 'alo-blanco',
        name: 'Blanco',
        description: 'Gorra ALO premium en blanco. Silueta trucker limpia, logo bordado en relieve y malla transpirable.',
        acabado: 'Bordado 3D / malla trucker, color blanco',
        image: '/assets/logo-shop-circle.webp', // PLACEHOLDER — pendiente foto real
        animation: null,
        gallery: [
          { type: 'image', src: '/assets/logo-shop-circle.webp', label: 'Vista General' }, // PLACEHOLDER
        ],
      },
      {
        // TEMPORAL: imagen de placeholder (logo de QUINLATE) mientras llegan las fotos
        // reales de producto. Buscar "PLACEHOLDER" para encontrar esta variante y
        // reemplazar "image"/"gallery" en cuanto lleguen las fotos.
        id: 'alo-blanco-negro',
        name: 'Blanco/Negro',
        description: 'Gorra ALO premium en blanco y negro. Silueta trucker limpia, logo bordado en relieve y malla transpirable.',
        acabado: 'Bordado 3D / malla trucker, blanco/negro',
        image: '/assets/logo-shop-circle.webp', // PLACEHOLDER — pendiente foto real
        animation: null,
        gallery: [
          { type: 'image', src: '/assets/logo-shop-circle.webp', label: 'Vista General' }, // PLACEHOLDER
        ],
      },
    ],
  },
  {
    id: 'paquete-emprendedor-alo',
    name: 'Paquete Emprendedor — 3 Gorras ALO',
    category: 'emprendedor',
    material: 'Edición premium',
    description: 'Paquete de 3 gorras ALO para revender. Silueta trucker limpia, logo bordado en relieve y malla transpirable. Precio especial por mayoreo.',
    price: '$1,500 MXN',
    image: '/assets/caja-emprendedor.webp',
    // Sin animation a proposito: las tarjetas corren en "modo vitrina" (autoRotate en
    // CategoryPage), que reproduce la animacion encima de la imagen en cuanto la tarjeta
    // entra en pantalla — taparia la foto de la caja, que es justo lo que se quiere
    // mostrar aqui. El giro 360 de la gorra solo va en la Gorra ALO (/gorras), no aqui.
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/caja-emprendedor.webp', label: 'Empaque' },
      { type: 'image', src: '/assets/alo-front.webp', label: 'Frente' },
      { type: 'image', src: '/assets/alo-side.webp', label: 'Perfil' },
      { type: 'image', src: '/assets/alo-back.webp', label: 'Trasera' },
    ],
    contents: [
      { qty: 1, name: 'Gorra ALO Negro', src: '/assets/alo-poster.webp' },
      { qty: 1, name: 'Gorra ALO Blanco', src: '/assets/logo-shop-circle.webp' },
      { qty: 1, name: 'Gorra ALO Blanco/Negro', src: '/assets/logo-shop-circle.webp' },
    ],
    featured: false,
    details: {
      quilates: null,
      acabado: 'Bordado 3D / malla trucker',
      tallas: ['Incluye 3 piezas, unitalla ajustable'],
    },
  },
  // Paquetes de cadenas por mayoreo. Los 3 comparten estructura y solo cambian cantidad y
  // precio. Las fotos de tejido son ejemplos del surtido, no un contenido fijo — el
  // surtido lo define QUINLATE, como dice la descripcion.
  {
    id: 'paquete-emprendedor-cadenas-5',
    name: 'Paquete Emprendedor — 5 Cadenas',
    category: 'emprendedor',
    material: 'Laminado en oro 18k',
    description: 'Paquete de 5 cadenas laminadas en oro 18k para revender. Surtido de tejidos seleccionado por QUINLATE. Precio especial por mayoreo.',
    price: '$1,900 MXN',
    image: '/assets/caja-emprendedor.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/caja-emprendedor.webp', label: 'Empaque' },
      { type: 'image', src: '/assets/torzal-frontal.webp', label: 'Tejido Torzal' },
      { type: 'image', src: '/assets/torzal-cartier-frontal.webp', label: 'Tejido Cartier' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-frontal.webp', label: 'Tejido Gucci' },
      { type: 'image', src: '/assets/tejido-torzal-barbado-frontal.webp', label: 'Tejido Barbado' },
    ],
    contents: [
      { qty: 2, name: 'Tejido Gucci', src: '/assets/tejido-torzal-gucci-frontal.webp' },
      { qty: 2, name: 'Tejido Barbado', src: '/assets/tejido-torzal-barbado-frontal.webp' },
      { qty: 1, name: 'Tejido Torzal', src: '/assets/torzal-frontal.webp' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Surtido de tejidos',
      tallas: ['Incluye 5 piezas'],
    },
  },
  {
    id: 'paquete-emprendedor-cadenas-12',
    name: 'Paquete Emprendedor — 12 Cadenas',
    category: 'emprendedor',
    material: 'Laminado en oro 18k',
    description: 'Paquete de 12 cadenas laminadas en oro 18k para revender. Surtido de tejidos seleccionado por QUINLATE, ideal para surtir tu negocio. Precio especial por mayoreo.',
    price: '$4,200 MXN',
    image: '/assets/caja-emprendedor.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/caja-emprendedor.webp', label: 'Empaque' },
      { type: 'image', src: '/assets/torzal-frontal.webp', label: 'Tejido Torzal' },
      { type: 'image', src: '/assets/torzal-cartier-frontal.webp', label: 'Tejido Cartier' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-frontal.webp', label: 'Tejido Gucci' },
      { type: 'image', src: '/assets/tejido-torzal-barbado-frontal.webp', label: 'Tejido Barbado' },
    ],
    contents: [
      { qty: 3, name: 'Tejido Torzal', src: '/assets/torzal-frontal.webp' },
      { qty: 3, name: 'Tejido Cartier', src: '/assets/torzal-cartier-frontal.webp' },
      { qty: 3, name: 'Tejido Gucci', src: '/assets/tejido-torzal-gucci-frontal.webp' },
      { qty: 3, name: 'Tejido Barbado', src: '/assets/tejido-torzal-barbado-frontal.webp' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Surtido de tejidos',
      tallas: ['Incluye 12 piezas'],
    },
  },
  {
    id: 'paquete-emprendedor-cadenas-24',
    name: 'Paquete Emprendedor — 24 Cadenas',
    category: 'emprendedor',
    material: 'Laminado en oro 18k',
    description: 'Paquete de 24 cadenas laminadas en oro 18k para revender. Surtido de tejidos seleccionado por QUINLATE, nuestro mejor precio por pieza. Precio especial por mayoreo.',
    price: '$7,500 MXN',
    image: '/assets/caja-emprendedor.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/caja-emprendedor.webp', label: 'Empaque' },
      { type: 'image', src: '/assets/torzal-frontal.webp', label: 'Tejido Torzal' },
      { type: 'image', src: '/assets/torzal-cartier-frontal.webp', label: 'Tejido Cartier' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-frontal.webp', label: 'Tejido Gucci' },
      { type: 'image', src: '/assets/tejido-torzal-barbado-frontal.webp', label: 'Tejido Barbado' },
    ],
    contents: [
      { qty: 6, name: 'Tejido Torzal', src: '/assets/torzal-frontal.webp' },
      { qty: 6, name: 'Tejido Cartier', src: '/assets/torzal-cartier-frontal.webp' },
      { qty: 6, name: 'Tejido Gucci', src: '/assets/tejido-torzal-gucci-frontal.webp' },
      { qty: 6, name: 'Tejido Barbado', src: '/assets/tejido-torzal-barbado-frontal.webp' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Surtido de tejidos',
      tallas: ['Incluye 24 piezas'],
    },
  },
  {
    id: 'tejido-torzal-gucci',
    name: 'Torzal Gucci',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Collar tejido estilo Gucci, laminado en oro 18k. Un giro distinto sobre el clásico torzal.',
    price: '$750 MXN',
    pairId: 'esclava-tejido-gucci',
    // El 360 se llama torzal-cartier.webp por historia, pero muestra tejido mariner, que es
    // el Gucci. Antes estaba mal etiquetado como Cartier.
    image: '/assets/torzal-cartier-poster.webp',
    animation: '/assets/torzal-cartier.webp',
    gallery: [
      { type: 'animation', src: '/assets/torzal-cartier.webp', label: 'Video 360°' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-frontal.webp', label: 'Vista' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Gucci pulido a espejo',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'torzal',
    name: 'Torzal',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Tejido clásico torzal, laminado en oro 18k. Tradición artesanal mexicana en cada giro de la cuerda.',
    price: '$750 MXN',
    pairId: 'esclava-tejido-torzal',
    // image = primer frame del 360, para que la tarjeta arranque sin salto visual cuando
    // el modo vitrina empieza a reproducir la animacion encima.
    image: '/assets/torzal-poster.webp',
    animation: '/assets/torzal.webp',
    gallery: [
      { type: 'animation', src: '/assets/torzal.webp', label: 'Video 360°' },
      { type: 'image', src: '/assets/torzal-frontal.webp', label: 'Vista' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Trenzado torzal artesanal',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'rosario',
    name: 'Rosario',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Rosario en oro con crucifijo detallado y medalla devocional. Fe y artesanía unidas en una pieza eterna.',
    price: '$850 MXN',
    image: '/assets/rosario-poster.webp',
    animation: '/assets/rosario.webp',
    gallery: [
      { type: 'animation', src: '/assets/rosario.webp', label: 'Video 360°' },
      { type: 'image', src: '/assets/rosario-frontal.webp', label: 'Vista' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Crucifijo y medalla en relieve',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'chrome-hearts',
    name: 'Chrome Hearts',
    category: 'gorras',
    material: 'Trucker edition',
    description: 'Trucker cap Chrome Hearts con cruces bordadas en blanco. Malla negra, actitud total.',
    price: '$999 MXN',
    image: '/assets/chrome-hearts-poster.webp',
    animation: '/assets/chrome-hearts.webp',
    gallery: [
      { type: 'animation', src: '/assets/chrome-hearts.webp', label: 'Video 360°' },
      { type: 'image', src: '/assets/chrome-front.webp', label: 'Frente' },
      { type: 'image', src: '/assets/chrome-side.webp', label: 'Perfil' },
    ],
    featured: false,
    details: {
      quilates: null,
      acabado: 'Parche de cruces bordado',
      tallas: ['Unitalla ajustable'],
    },
  },
  {
    id: 'torzal-cartier',
    name: 'Torzal Cartier',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Cadena estilo Cartier en tejido figaro, laminada en oro 18k. Un eslabón largo seguido de tres cortos que capturan destellos de luz.',
    price: '$750 MXN',
    pairId: 'esclava-tejido-cartier',
    image: '/assets/torzal-cartier-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/torzal-cartier-frontal.webp', label: 'Vista' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Cartier (figaro) pulido a espejo',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'tejido-torzal-barbado',
    name: 'Tejido Torzal Barbado (Cuello)',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Collar tejido torzal barbado, laminado en oro 18k. Textura marcada, presencia fuerte.',
    price: '$750 MXN',
    pairId: 'esclava-tejido-barbado',
    image: '/assets/tejido-torzal-barbado-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/tejido-torzal-barbado-frontal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/tejido-torzal-barbado-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Barbado',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'esclava-tejido-torzal',
    name: 'Esclava Tejido Torzal',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida a juego con el collar Torzal. Tradición artesanal mexicana en cada giro de la cuerda.',
    price: '$350 MXN',
    pairId: 'torzal',
    image: '/assets/esclava-tejido-torzal-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/esclava-tejido-torzal-frontal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/esclava-tejido-torzal-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'esclava-tejido-cartier',
    name: 'Esclava Tejido Cartier',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida a juego con el collar Cartier, laminada en oro 18k. Eslabones trenzados con destellos de luz.',
    price: '$350 MXN',
    pairId: 'torzal-cartier',
    image: '/assets/esclava-tejido-cartier-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/esclava-tejido-cartier-frontal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/esclava-tejido-cartier-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Cartier',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'esclava-tejido-gucci',
    name: 'Esclava Tejido Gucci',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida a juego con el collar Torzal Gucci.',
    price: '$250 MXN',
    pairId: 'tejido-torzal-gucci',
    image: '/assets/esclava-tejido-gucci-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/esclava-tejido-gucci-frontal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/esclava-tejido-gucci-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Gucci',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'esclava-tejido-barbado',
    name: 'Esclava Tejido Barbado',
    category: 'joyeria',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida a juego con el collar Torzal Barbado.',
    price: '$350 MXN',
    pairId: 'tejido-torzal-barbado',
    image: '/assets/esclava-tejido-barbado-frontal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/esclava-tejido-barbado-frontal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/esclava-tejido-barbado-detalle.webp', label: 'Detalle' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Barbado',
      tallas: ['Talla única'],
    },
  },
  // TEMPORAL: imagen de placeholder (logo de QUINLATE) mientras llegan las fotos reales
  // de producto (el usuario las esta generando con Google Flow). Buscar "PLACEHOLDER"
  // para encontrar estos productos y reemplazar "image"/"gallery" en cuanto lleguen.
  {
    id: 'pulso-monaco-chain',
    name: 'Pulso Monaco Chain',
    category: 'joyeria',
    // Oculto hasta tener su foto real (pedido del colaborador, 2026-10-17): se vendía con
    // el logo como foto. Para mostrarlo, quitar esta línea y reemplazar las PLACEHOLDER.
    hidden: true,
    material: 'Laminado en oro 18k',
    description: 'Pulso Monaco Chain laminado en oro 18k. Eslabones robustos con brillo espejo.',
    price: '$1,499 MXN',
    image: '/assets/logo-shop-circle.webp', // PLACEHOLDER — pendiente foto real
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/logo-shop-circle.webp', label: 'Vista General' }, // PLACEHOLDER
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Eslabón Monaco Chain',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'van-cleef-negro',
    name: 'Esclava Van Cleef — Negro',
    category: 'van-cleef',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida estilo Van Cleef con acabado en negro. Diseño clásico con una actitud distinta.',
    price: '$1,499 MXN',
    image: '/assets/van-cleef-negro.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/van-cleef-negro.webp', label: 'Vista General' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Van Cleef, color negro',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'van-cleef-verde',
    name: 'Esclava Van Cleef — Verde',
    category: 'van-cleef',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida estilo Van Cleef con acabado en verde. Diseño clásico con una actitud distinta.',
    price: '$1,499 MXN',
    image: '/assets/van-cleef-verde.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/van-cleef-verde.webp', label: 'Vista General' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Van Cleef, color verde',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'van-cleef-rojo',
    name: 'Esclava Van Cleef — Rojo',
    category: 'van-cleef',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida estilo Van Cleef con acabado en rojo. Diseño clásico con una actitud distinta.',
    price: '$1,499 MXN',
    image: '/assets/van-cleef-rojo.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/van-cleef-rojo.webp', label: 'Vista General' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Van Cleef, color rojo',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'van-cleef-blanco',
    name: 'Esclava Van Cleef — Blanco',
    category: 'van-cleef',
    material: 'Laminado en oro 18k',
    description: 'Esclava tejida estilo Van Cleef con acabado en blanco. Diseño clásico con una actitud distinta.',
    price: '$1,499 MXN',
    image: '/assets/van-cleef-blanco.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/van-cleef-blanco.webp', label: 'Vista General' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Van Cleef, color blanco',
      tallas: ['Talla única'],
    },
  },
  // TEMPORAL: imagen de placeholder (logo de QUINLATE) mientras llegan las fotos reales.
  // Estos 4 son combos (collar + esclava a juego) con precio de paquete — se modelan
  // como un producto normal, no con el mecanismo "+ Agregar X a juego" de ProductModal.
  {
    id: 'conjunto-torzal',
    name: 'Conjunto Torzal + Esclava',
    category: 'conjuntos',
    material: 'Laminado en oro 18k',
    description: 'Collar Torzal tejido + esclava a juego. Precio especial por comprar el conjunto completo.',
    price: '$999 MXN',
    image: '/assets/conjunto-torzal.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/conjunto-torzal.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/torzal-frontal.webp', label: 'Collar' },
      { type: 'image', src: '/assets/esclava-tejido-torzal-frontal.webp', label: 'Esclava' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal (collar + esclava)',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'conjunto-cartier',
    name: 'Conjunto Cartier + Esclava',
    category: 'conjuntos',
    material: 'Laminado en oro 18k',
    description: 'Collar Cartier tejido + esclava a juego. Precio especial por comprar el conjunto completo.',
    price: '$999 MXN',
    image: '/assets/conjunto-cartier.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/conjunto-cartier.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/torzal-cartier-frontal.webp', label: 'Collar' },
      { type: 'image', src: '/assets/esclava-tejido-cartier-frontal.webp', label: 'Esclava' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Cartier (collar + esclava)',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'conjunto-torzal-gucci',
    name: 'Conjunto Torzal Gucci + Esclava',
    category: 'conjuntos',
    material: 'Laminado en oro 18k',
    description: 'Collar Torzal Gucci tejido + esclava a juego. Precio especial por comprar el conjunto completo.',
    price: '$799 MXN',
    image: '/assets/conjunto-torzal-gucci.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/conjunto-torzal-gucci.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/tejido-torzal-gucci-frontal.webp', label: 'Collar' },
      { type: 'image', src: '/assets/esclava-tejido-gucci-frontal.webp', label: 'Esclava' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Gucci (collar + esclava)',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'conjunto-torzal-barbado',
    name: 'Conjunto Torzal Barbado + Esclava',
    category: 'conjuntos',
    material: 'Laminado en oro 18k',
    description: 'Collar Torzal Barbado tejido + esclava a juego. Precio especial por comprar el conjunto completo.',
    price: '$999 MXN',
    image: '/assets/conjunto-torzal-barbado.webp',
    animation: null,
    gallery: [
      { type: 'image', src: '/assets/conjunto-torzal-barbado.webp', label: 'Vista General' },
      { type: 'image', src: '/assets/tejido-torzal-barbado-frontal.webp', label: 'Collar' },
      { type: 'image', src: '/assets/esclava-tejido-barbado-frontal.webp', label: 'Esclava' },
    ],
    featured: false,
    details: {
      quilates: 'Laminado en oro 18k',
      acabado: 'Tejido Torzal Barbado (collar + esclava)',
      tallas: ['Talla única'],
    },
  },
  {
    id: 'lentes-modelo-a',
    name: 'Mift Big C',
    category: 'lentes',
    material: 'Metal dorado, sin marco (rimless)',
    description: 'Lentes rimless estilo Cartier con herrajes dorados y bisagra decorativa en las esquinas.',
    price: '$1,250 MXN',
    image: '/assets/lentes-zafiro.webp',
    animation: null,
    gallery: [{ type: 'image', src: '/assets/lentes-zafiro.webp', label: 'Vista' }],
    featured: false,
    details: {
      quilates: null,
      acabado: 'Metal dorado, sin marco (rimless)',
      tallas: null,
    },
    variants: [
      {
        id: 'lentes-zafiro',
        name: 'Azul',
        description: 'Lentes rimless estilo Cartier con herrajes dorados. Cristales azul degradado que capturan la luz como el cielo al amanecer.',
        acabado: 'Metal dorado, sin marco (rimless) — lente degradado azul claro',
        image: '/assets/lentes-zafiro.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-zafiro.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-panthere-optico',
        name: 'Transparente',
        description: 'Lentes rimless estilo Cartier con herrajes dorados. Cristales transparentes, limpios y ligeros, para usarse de día o de noche.',
        acabado: 'Metal dorado, sin marco (rimless) — lente transparente (sin graduación)',
        image: '/assets/lentes-panthere-optico.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-panthere-optico.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-ambar',
        name: 'Café',
        description: 'Lentes rimless estilo Cartier con herrajes dorados. Cristales ámbar degradados que envuelven la mirada en un brillo cálido.',
        acabado: 'Metal dorado, sin marco (rimless) — lente degradado ámbar/marrón',
        image: '/assets/lentes-ambar.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-ambar.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-onix',
        name: 'Negro',
        description: 'Lentes rimless estilo Cartier con herrajes dorados. Cristales negro sólido que proyectan una actitud directa, sin distracciones.',
        acabado: 'Metal dorado, sin marco (rimless) — lente negro sólido, acabado brillante',
        image: '/assets/lentes-onix.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-onix.webp', label: 'Vista' }],
      },
    ],
  },
  {
    id: 'lentes-modelo-b',
    name: 'Pantheré',
    category: 'lentes',
    material: 'Metal dorado, sin marco (rimless)',
    description: 'Lentes rimless estilo Cartier con herrajes dorados y cabeza de felino esculpida en las esquinas.',
    price: '$1,250 MXN',
    image: '/assets/lentes-panthere.webp',
    animation: null,
    gallery: [{ type: 'image', src: '/assets/lentes-panthere.webp', label: 'Vista' }],
    featured: false,
    details: {
      quilates: null,
      acabado: 'Metal dorado, sin marco (rimless)',
      tallas: null,
    },
    variants: [
      {
        id: 'lentes-panthere',
        name: 'Rosa',
        description: 'Lentes rimless estilo Cartier con cabeza de felino dorada en las esquinas. Cristales rosa nude degradados, suaves y luminosos.',
        acabado: 'Metal dorado, sin marco (rimless) — lente degradado rosa nude',
        image: '/assets/lentes-panthere.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-panthere.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-glaciar',
        name: 'Transparente',
        description: 'Lentes rimless estilo Cartier con cabeza de felino dorada en las esquinas. Cristales transparentes, limpios y ligeros.',
        acabado: 'Metal dorado, sin marco (rimless) — lente transparente (sin graduación)',
        image: '/assets/lentes-glaciar.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-glaciar.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-habano',
        name: 'Café',
        description: 'Lentes rimless estilo Cartier con cabeza de felino dorada en las esquinas. Cristales café degradados, de tono profundo arriba a miel abajo.',
        acabado: 'Metal dorado, sin marco (rimless) — lente degradado café/miel',
        image: '/assets/lentes-habano.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-habano.webp', label: 'Vista' }],
      },
      {
        id: 'lentes-ebano',
        name: 'Negro',
        description: 'Lentes rimless estilo Cartier con cabeza de felino dorada en las esquinas. Cristales negro profundo y envolvente.',
        acabado: 'Metal dorado, sin marco (rimless) — lente negro sólido, acabado brillante',
        image: '/assets/lentes-ebano.webp',
        gallery: [{ type: 'image', src: '/assets/lentes-ebano.webp', label: 'Vista' }],
      },
    ],
  },
];

// Los productos con `hidden: true` no aparecen en ningún lado de la tienda (categorías,
// conteos de la portada, buscador, carrito). Siguen en CATALOG_MIN_PRICE_MXN del servidor,
// así que mostrarlos de nuevo es solo quitar la marca.
export const products = ALL_PRODUCTS.filter((p) => !p.hidden);
